import React from "react";
import styles from "./TableData.module.css";

export const TableData = ({ align, ...props }) => (
  <td
    {...props}
    data-align={align}
    className={[styles.TableData, props.className].join(" ")}
  />
);
